import React, {FunctionComponent} from "react";
import {Redirect} from "react-router-dom";

export const CompareEverythingForward: FunctionComponent = () => {
    return (
        <Redirect to={"/compare/all/"}/>
    )
}